import { useOrganizationStore } from '@/store/organization.store';

export function useOrganization() {
  return useOrganizationStore();
}
